import { LAST_QUESTION_ID } from "../data/uniqueValues"
import { results } from "../data/results"

export const formatQuizData = (data) => {
  return data.map((d) => ({
    qId: Number(d.qId),
    question: String(d.question),
    response: String(d.response),
    possibleResultsIds: d.possibleResultsIds
      .split(",")
      .map((d) => Number(d))
      .filter((d) => d !== 0),
    nextQId: typeof d.nextQId === "number" ? d.nextQId : null,
  }))
}

export const formatFinalData = (rawData) => {
  const data = formatQuizData(rawData)
  const allQIds = [...new Set(data.map((d) => d.qId))]
  return allQIds.map((id) => {
    const options = data.filter((d) => d.qId === id)
    return {
      qId: id,
      text: options[0].question,
      options: options.map((option) => ({
        text: option.response,
        nextQId: option.nextQId,
        possibleResultsIds: option.possibleResultsIds,
      })),
    }
  })
}

export const formatUserChoicesData = (data, questionData) => {
  if (data.length === 0) {
    return [formatShowNewQuestion(questionData)]
  }
  const oldQuestion = data[data.length - 1]
  return [oldQuestion, questionData]
}

export const formatShowNewQuestion = (questionData) => ({
  ...questionData,
  showQuestion: true,
  options: questionData.options.map((d, i) => ({
    ...d,
    optionId: i,
    selected: false,
  })),
})

// Removes options that don't match with previous user choices
export const removeIrrelevantOptions = (question, possibleResultsIds) => {
  const filteredOptions = question.options.filter((option) =>
    possibleResultsIds.some((id) => option.possibleResultsIds.indexOf(id) >= 0)
  )
  return {
    ...question,
    options: filteredOptions,
  }
}

export const getNextQuestionWithOptions = (
  nextQuestion,
  filteredPossibleResults,
  nextQId,
  data
) => {
  const nextQuestion2 = removeIrrelevantOptions(
    nextQuestion,
    filteredPossibleResults
  )

  // Start looking from next question, since current
  // question already has no options
  let qId = nextQId + 1
  let newNextQuestion = nextQuestion2
  let skipToResults = false
  if (nextQuestion2.options.length === 0) {
    // console.log("skipping questions...")
    // Keep progressing through the quiz till you get
    // a question with options
    while (qId < 16) {
      const question = data.find((d) => d.qId === qId)

      const formattedQuestion = removeIrrelevantOptions(
        question,
        filteredPossibleResults
      )
      // console.log({ qId, formattedQuestion })

      if (formattedQuestion.options.length > 0) {
        newNextQuestion = formattedQuestion
        break
      }
      // If no questions found, show results
      if (qId === LAST_QUESTION_ID && formattedQuestion.options.length === 0) {
        skipToResults = true
      }
      // Move to next question. Using +1 cauz in this quiz
      // the flow of questions is in +1 format
      qId += 1
    }
  }
  return {
    question: newNextQuestion,
    skipToResults,
  }
}

export const getImagesFromResultIds = (resultIds) => {
  const images = resultIds.flatMap((id) => {
    const { imgURL, imgURL2, imgURL3 } = results.find((d) => d.resultId === id)
    if (imgURL && imgURL2 && imgURL3) return [imgURL, imgURL2, imgURL3]
    else if (imgURL && imgURL2) return [imgURL, imgURL2]
    else return [imgURL]
  })
  return images
}
